/**
 * Pure mapping from the `protos.vision.chat.v1.VisionChatMessage` proto to the flat message shape
 * the legacy `ChatPanel` / `ChatMessage` components read (`id`, `user_id`, `content`,
 * `display_name`, `created_at`, `reply_to_*`). Shared by the gRPC client (list / create responses)
 * and the realtime adapter (the `vision_chat_message_created` event) so both render an identical row.
 *
 * `author_name` is the resolved account name; an empty value maps through the component's
 * `resolveAuthorName` fallback (DELETED_USER_NAME). The body is read from the `text` arm of the
 * `data` oneof.
 */

import { timestampDate } from '@bufbuild/protobuf/wkt';

export function chatMessageToLegacy(message) {
  const text = message.data?.case === 'text' ? message.data.value.text : '';
  const createdAt = message.createdAt
    ? timestampDate(message.createdAt).toISOString()
    : new Date().toISOString();
  const reply = message.replyTo;

  return {
    id: message.messageId,
    project_id: message.projectId,
    image_id: message.imageId,
    user_id: message.authorAccountId,
    content: text,
    display_name: message.authorName,
    username: message.authorName,
    created_at: createdAt,
    reply_to_id: reply?.messageId || null,
    reply_to_content: reply?.textPreview || null,
    reply_to_display_name: reply?.authorName || null,
    reply_to_username: reply?.authorName || null,
  };
}

/** Map the `ListImageChatCounts` response to the `{ [imageId]: count }` map the artboard reads. */
export function chatCountsToMap(counts) {
  const map = {};
  for (const { imageId, messageCount } of counts ?? []) {
    map[imageId] = messageCount;
  }
  return map;
}
